import { Input } from "../../ui/Input";
export const CompanyDetailForm =({ formData}) =>{
  
    return(
        <div className="transaction-form">
                
                <Input
                        label="Company Name"
                        type="text"
                        name="CompanyName"
                        value={formData.CompanyName}
                        disabled={true}
                      />
                      <h4>Company Address</h4>
                  <Input
                        label="Address Line 1 "
                        type="text"
                        name="Address1"
                        value={formData.Address1}
                        disabled={true}
                      />
                      <Input
                        label="Address Line 2 "
                        type="text"
                        name="Address2"
                        value={formData.Address2}
                        disabled={true}
                      />
                      <Input
                        label="Address Line 3 "
                        type="text"
                        name="Address3"
                        value={formData.Address3}
                        disabled={true}
                      />
                      <Input
                        label="State/Province "
                        type="text"
                        name="State"
                        value={formData.State}
                        disabled={true}
                      />
                      <Input
                        label="Country"
                        type="text"
                        name="Country"
                        value={formData.Country}
                        disabled={true}
                      />
                </div>
    )
}